import styled from 'styled-components';
import { COLORS } from '@/styles/colorTheme';

export const Container = styled.div`
  border: ${(props) =>
    props.isAdded ? `1px solid ${COLORS.Primary500}` : `1px solid ${COLORS.Background200}`};
  background: ${(props) => (props.isAdded ? `` : `#fff`)};

  :hover {
    background: ${(props) => (props.isAdded ? `` : `${COLORS.Background50}`)};
  }
`;
